import { useContext, useEffect, useState } from 'react'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import {
  SalesCodeComplexityContext,
  SET_SHOW_HIDE_DETAILS_POPUP,
} from './context/context'
import { getRequest } from '../../../../services/base'
import { useParams } from 'react-router-dom'
import Tooltip from '../../../common/tooltip'
import { downloadErrorLogs, downloadFile } from '../../../../utils/common'
import InputText from '../../../common/InputText'
import { NavContext } from '../../../../context/global_context'
import NoRecordsFound from '../../../common/NoRecordsFound'

const SalesCodeDetails = () => {
  const { vehicle } = useParams()
  const [salesCodeState, salesCodeDispatch] = useContext(
    SalesCodeComplexityContext
  )
  const [state, dispatch] = useContext(NavContext)

  const [salesCodeDetails, setSalesCodeDetails] = useState({})
  const [salesCodeDetailsList, setSalesCodeDetailsList] = useState([])

  useEffect(() => {
    if (salesCodeState?.showDetailsPopup?.id) {
      getSalesCodeComplexityDetails(salesCodeState?.showDetailsPopup?.id)
    }
  }, [salesCodeState?.showDetailsPopup?.id])

  const getSalesCodeComplexityDetails = async (id) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Fetching Sales Code Details Data',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/plugin/sales_code/sales-code-details/${id}/?vehicle=${vehicle}`
    )
    setSalesCodeDetails(res.data)
    setSalesCodeDetailsList(res.data.sales_code_details)
    dispatch({
      type: 'loader',
      data: {},
      notification: {},
    })
  }

  const searchSalesCodeOrPartNumber = (seachValue, column) => {
    let filteredSalesCodeData = []
    if (seachValue) {
      filteredSalesCodeData = salesCodeDetails.sales_code_details.filter(
        (row) => row[column].toLowerCase().includes(seachValue.toLowerCase())
      )
    } else {
      filteredSalesCodeData = salesCodeDetails.sales_code_details
    }
    setSalesCodeDetailsList(filteredSalesCodeData)
  }

  return (
    <Modal
      onClose={() => {
        salesCodeDispatch({
          type: SET_SHOW_HIDE_DETAILS_POPUP,
          data: {},
        })
      }}
      show={salesCodeState?.showDetailsPopup?.id ? true : false}
    >
      <ModalHeader className={'text-white'}>Sales Code Complexity</ModalHeader>
      <ModalBody>
        <div>
          <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
            <div className="flex w-6/12 items-center justify-center">
              {salesCodeState?.showDetailsPopup?.name}
            </div>
            <div
              className={`flex ${salesCodeDetails?.logs?.error?.length > 0 ? 'w-3/12' : 'w-6/12'} items-center justify-center cursor-pointer underline text-blue-500`}
              onClick={() => {
                downloadFile(
                  `${salesCodeState?.showDetailsPopup?.file}?timestamp=${Number(new Date())}`,
                  salesCodeState?.showDetailsPopup?.name
                )
              }}
            >
              Download Source File
            </div>
            {salesCodeDetails?.logs?.error?.length > 0 && (
              <div
                className="flex w-3/12 items-center justify-center cursor-pointer underline text-blue-500"
                onClick={() => {
                  downloadErrorLogs(salesCodeDetails?.logs?.error)
                }}
              >
                Download Errors
              </div>
            )}
          </div>
        </div>
        {salesCodeDetailsList.length > 0 ? (
          <div>
            <div className="font-light mt-3">
              <div className="flex flex-row w-full bg-tracer-lt-blue rounded-t-lg text-white px-3 text-sm">
                <div className="flex w-1/12 items-center justify-center"></div>
                <div className="flex w-6/12 items-center">Sales Code</div>
                <div className="flex w-5/12 pl-6 items-center">Part Number</div>
              </div>
            </div>
            <div className="font-light">
              <div className="flex flex-row w-full  text-white px-3 text-sm">
                <div className="flex w-1/12 items-center justify-center"></div>
                <div className="flex w-6/12 items-center">
                  <div className="py-1 w-full pr-2">
                    <InputText
                      isFullSize={false}
                      placeholder="Enter to Search Sales Code"
                      name="sales_code"
                      onChange={(value) => {
                        searchSalesCodeOrPartNumber(value, 'sales_code')
                      }}
                      type="text"
                    />
                  </div>
                </div>
                <div className="flex w-5/12 pl-6 items-center">
                  <div className="py-1 w-full">
                    <InputText
                      isFullSize={false}
                      placeholder="Enter to Search Part Number"
                      name="part_number"
                      onChange={(value) => {
                        searchSalesCodeOrPartNumber(value, 'part_number')
                      }}
                      type="text"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              style={{
                maxHeight: '30vh',
                overflowY: 'scroll',
                position: 'relative',
              }}
            >
              {salesCodeDetailsList?.map((sales_code_detail, index) => {
                return (
                  <div
                    key={`sales-code-details-${index}`}
                    className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black"
                  >
                    <div className="flex w-1/12 items-center justify-center">
                      {index + 1}
                    </div>
                    <div className="flex w-6/12 items-center table_text">
                      <Tooltip
                        position={'top'}
                        message={sales_code_detail.sales_code}
                      >
                        <div>{sales_code_detail.sales_code}</div>
                      </Tooltip>
                    </div>
                    <div className="flex w-5/12 pl-6 items-center table_text">
                      <Tooltip
                        position={'top'}
                        message={sales_code_detail.part_number}
                      >
                        <div>{sales_code_detail.part_number}</div>
                      </Tooltip>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        ) : (
          <NoRecordsFound caption={`Data not imported in system`} />
        )}
      </ModalBody>
    </Modal>
  )
}

export default SalesCodeDetails
